import { queryOptions } from "@tanstack/react-query";
import { type Api, getBillingOverview, listBillingProducts } from "api-client";

import { BILLING_CURRENCY } from "src/helpers/billingConfig";

export type BillingProduct = Api.ListBillingProducts.Output.Product;
export type BillingPrice = Api.ListBillingProducts.Output.Price;
export type BillingOverview = Api.GetBillingOverview.Output.Self;
export type BillingSubscription = Api.GetBillingOverview.Output.Subscription;
export type BillingSubscriptionUpdatePreview =
  Api.PreviewSubscriptionUpdate.Output.Self;
export type BillingInvoice = BillingOverview["invoices"][number];

const BILLING_QUERY_GC_TIME = 5 * 60_000;

export function billingProductsQueryOptions() {
  return queryOptions({
    queryKey: ["billing", "products"],
    gcTime: BILLING_QUERY_GC_TIME,
    queryFn: async () => {
      const response = await listBillingProducts({
        query: { currency: BILLING_CURRENCY },
      });
      return response.data.data;
    },
  });
}

export function billingOverviewQueryOptions() {
  return queryOptions({
    queryKey: ["billing", "overview"],
    gcTime: BILLING_QUERY_GC_TIME,
    queryFn: async () => {
      const response = await getBillingOverview();
      return response.data.data;
    },
  });
}
